// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__Q_5L1","header":"index_header__xZxZ0","main":"index_main__rS5Nx","rights":"index_rights__x0f5J","bottomIntro":"index_bottomIntro__2efTg"};